import React, { useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

interface ElementSize {
  width: number;
  height: number;
}

// Source: https://stackoverflow.com/questions/68175873/detect-element-reference-height-change
export const useSize = (elementRef: React.RefObject<HTMLElement>): ElementSize => {
  const [elementSize, setElementSize] = useState<ElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!elementRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setElementSize({ width, height });
      }
    });

    if (elementRef.current) {
      resizeObserver.observe(elementRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef]);

  return elementSize;
};
